import {
  FlexBox,
  space,
  Typography,
} from "@waldner-laboreinrichtungen/component-system";
import { useTranslation } from "react-i18next";

export const Contact = () => {
  const { t } = useTranslation();
  return (
    <FlexBox flexDirection="column" gap={space(2)}>
      <Typography weight="semiBold">WALDNER Group</Typography>
      <Typography>Anton-Waldner-Straße 10-16</Typography>
      <Typography>88239 Wangen im Allgäu</Typography>
      <Typography>Tel. +49 7522 986-0</Typography>
      <Typography marginTop={space(3)} weight="semiBold">
        {t("contact.dosomat_filling_machines")}:
      </Typography>
      <Typography>{t("contact.sales")}: +49 7522 986-255</Typography>
      <Typography>{t("contact.service")}: +49 7522 986-431</Typography>
      <Typography marginTop={space(3)} weight="semiBold">
        {t("contact.process_systems")}:
      </Typography>
      <Typography>
        {t("contact.sales_and_service")}: +49 7522 986-474{" "}
      </Typography>
      <Typography marginTop={space(3)} weight="semiBold">
        {t("contact.lab_solutions")}:
      </Typography>
      <Typography>{t("contact.sales")}: +49 7522 986-0</Typography>
      <Typography>{t("contact.service")}: +49 7522 986-7888</Typography>
    </FlexBox>
  );
};
